import styled from 'styled-components'
import React, { useContext } from 'react'
import { requestTranslation } from '@futures-platform/i18n'
import { Modal, paddingModalStyles } from '@futures-platform/ui'
// import { InfoCircle } from '@styled-icons/boxicons-regular'
import { PUBLIC_URL } from '../../env'
// import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import Review from './Review'

const ActivatedScenarioModal = ({
  InfoModalClose,
  gid,
  isReviewModalOpened,
  data,
  relatedPhenomena,
  relatedScenarios,
  historyDataState,
}) => {
  const {
    state: { scenarioSet },
    dispatch,
  } = useContext(DataContext)

  const openScenarioSetHandler = () => {
    window.location.replace(
      `${PUBLIC_URL}/scenario-wizard?gid=${gid}&scenario-set-id=${scenarioSet?.id}`,
    )
  }
  const createNewScenarioSetHandler = () => {
    window.location.href = `${PUBLIC_URL}/scenario-wizard?gid=${gid}`
  }

  return (
    <Modal
      onRequestClose={InfoModalClose}
      isOpen={isReviewModalOpened}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={paddingModalStyles}>
      <div className="confirmation-modal-content pt-4 pb-4">
        <Review
          data={data}
          gid={gid}
          InfoModalClose={InfoModalClose}
          relatedPhenomena={relatedPhenomena}
          relatedScenarios={relatedScenarios}
          historyDataState={historyDataState}
        />
      </div>
    </Modal>
  )
}

export default ActivatedScenarioModal

// const InformationIcon = styled(InfoCircle)`
//   background-color: white;
//   color: #00c3ff;
//   width: 45px;
//   height: 45px;
// `
const InformationUl = styled.ul`
  line-height: 2;
`
const InformationLi = styled.li`
  line-height: 1.4
  margin-top: 8px;
  margin-bottom: 8px;
`

const InformationLink = styled.p`
  color: #006998;
  &:hover {
    cursor: pointer;
  }
`
